import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    userId: null,
    error: null,
    loading: false,
    authRedirectPath: '/',
    isAuthenticated: false,
    role: null,
    expired: false
};

const authStart = ( state, action ) => {
    return updateObject( state, { error: null, loading: true } );
};

const authSuccess = (state, action) => {
    return updateObject( state, { 
        userId: action.userId,
        role: action.role,
        error: null,
        loading: false,
        isAuthenticated: true,
        expired: true
    });
};

const authFail = (state, action) => {
    return updateObject( state, {
        error: action.error,
        role: null,
        loading: false,
        isAuthenticated: false,
        expired: false
    });
};

const authLogout = (state, action) => {
    return updateObject(state, { 
        userId: null, 
        isAuthenticated: false, 
        role: null,
        expired: false
    });
};

const setExpiredTime = (state, action) => {
    return updateObject(state, { 
        expired: true
    });
};

const setAuthRedirectPath = (state, action) => {
    return updateObject(state, { 
        authRedirectPath: action.path,
        isAuthenticated: true 
    })
}

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.AUTH_START: return authStart(state, action);
        case actionTypes.AUTH_SUCCESS: return authSuccess(state, action);
        case actionTypes.AUTH_FAIL: return authFail(state, action);
        case actionTypes.AUTH_LOGOUT: return authLogout(state, action);
        case actionTypes.SET_AUTH_REDIRECT_PATH: return setAuthRedirectPath(state,action);
        case actionTypes.SET_EXPIRED_TIME: return setExpiredTime(state,action);
        default:
            return state;
    }
};

export default reducer;